const initialState = {
    nextList: [],
};
const nextListPurchase = (state = initialState, action) => {

    switch (action.type) {
        case 'ACTION_ADD_TO_NEXT_LIST':
            const {product, selectedVariant, seller, sku, title, number, image, price, priceSeparate, marketPrice, marketPriceSeparate, slug} = action.data; // gereftane etela@e mahsool
            const currentCartItem = {product, selectedVariant, seller, sku, title, number, image, price, priceSeparate, marketPrice, marketPriceSeparate, slug}; // amade kardane objecte mahsool jahate zakhire sazi ya taghirat
            const addCart = [...state.nextList]; // cart items before added or updated new row


            if(addCart.length !== 0) {
                let finded = false;
                addCart.forEach(cart => {
                    if(cart.sku === action.data.sku && cart.seller.id === action.data.seller.id) {
                        finded = true;
                    }
                });
                if(! finded) {
                    addCart.push(currentCartItem);
                }
            }
            else {
                addCart.push(currentCartItem);
            }


            return {...state, nextList:  addCart};
        case 'ACTION_REMOVE_FROM_NEXT_LIST':
            let new_carts = [];
        	if (state.nextList.length !== 0) {
        		state.nextList.forEach(product => {
        			if(product.sku !== action.data.sku || product.seller.id !== action.data.seller.id) {
        				new_carts.push(product);
                    }
	            });
        	}
            return {...state, nextList:  new_carts};
        case 'ACTION_REMOVE_ALL_ITEM_IN_NEXT_LIST':
            return {...state, nextList: []};
        default:
            return state;
    }
};

export default nextListPurchase;
